import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";

export const RouteGuard = React.memo(
  /**
   * A `Route` that redirects after checking a condition.
   *
   * @param {RouteGuardProps} props
   */
  function RouteGuard(props: any) {
    const _routeSecurityContext: any = useContext(RouteSecurityContext);
    const { check: securityCheck, ...security } = _routeSecurityContext;
    const check = props.check || securityCheck;
    const { children, render, ...rest } = props;
    const redirect = rest.redirect || security.redirect;
    return (
      <Route
        {...rest}
        render={(renderProps) => {
          const result = check({
            // Include default `auth,redirect` from `security`.
            ...security,
            // Include all props passed to RouteGuard, which are probably mostly
            // already in `renderProps` as well...
            ...props,
            // Include `auth,location,path,redirect,roles` from `rest`.
            ...renderProps,
          });
          if (result === true) {
            return children || render(renderProps);
          }
          // NOTE: The result should be a URL (string), a LocationDescriptor,
          // undefined or some other falsey value.
          return <Redirect to={result || redirect} />;
        }}
      />
    );
  },
);

/** @type {React.Context<RouteSecurityContextType>} */
const context: any = {};
export const RouteSecurityContext = React.createContext(context);

export const RouteSecurityProvider = React.memo(
  /**
   * @param {RouteSecurityContextType} param0
   */
  function RouteSecurityProvider(props: any) {
    const { children, ...context } = props;
    return (
      <RouteSecurityContext.Provider value={context}>{children}</RouteSecurityContext.Provider>
    );
  },
);
